import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { rect } from '#utilities/js/fixed/fixed.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button,
  ) => {
    const { ownerDocument, dataset, name } = button
    const { target } = dataset
    const containerCC = one(`.${elements.send_header_cc}`, ownerDocument)
    const containerBCC = one(`.${elements.send_header_bcc}`, ownerDocument)
    const header = one(`.${elements.send_header_main}`, ownerDocument)

    if (target === 'cc' && containerCC) {
      containerCC.classList.toggle(utilities.modifiers.display.none)

      if (!containerCC.classList.contains(utilities.modifiers.display.none)) {
        const headerFrom = one(`.${elements.send_header_from}`, ownerDocument)
        const { height: headerFromHeight } = rect(headerFrom)
        const headerTo = one(`.${elements.send_header_to}`, ownerDocument)
        const { height: headerToHeight } = rect(headerTo)
        header.scrollTo({ top: headerFromHeight + headerToHeight, behavior: 'smooth' })
      }
    }
    if (target === 'bcc' && containerBCC) {
      containerBCC.classList.toggle(utilities.modifiers.display.none)

      if (!containerBCC.classList.contains(utilities.modifiers.display.none)) {
        const headerFrom = one(`.${elements.send_header_from}`, ownerDocument)
        const { height: headerFromHeight } = rect(headerFrom)
        const headerTo = one(`.${elements.send_header_to}`, ownerDocument)
        const { height: headerToHeight } = rect(headerTo)
        header.scrollTo({ top: headerFromHeight + headerToHeight, behavior: 'smooth' })
      }
    }

    if ((name === 'buttonCC') || (name === 'buttonBCC')) {
      button.classList.toggle(utilities.modifiers.display.none)
      if (name === 'buttonCC') {
        const toggCC = one('button[name="toggCC"]', ownerDocument)
        if (toggCC) {
          toggCC.value = 'on'
          toggCC.setAttribute('aria-checked', true)
        }
      }
      if (name === 'buttonBCC') {
        const toggBCC = one('button[name="toggBCC"]', ownerDocument)
        if (toggBCC) {
          toggBCC.value = 'on'
          toggBCC.setAttribute('aria-checked', true)
        }
      }
    }
    if (name === 'toggCC') {
      const buttonCC = one('button[name="buttonCC"]', ownerDocument)
      if (buttonCC) {
        buttonCC.classList.toggle(utilities.modifiers.display.none)
      }
    }
    if (name === 'toggBCC') {
      const buttonBCC = one('button[name="buttonBCC"]', ownerDocument)
      if (buttonBCC) {
        buttonBCC.classList.toggle(utilities.modifiers.display.none)
      }
    }
  }
})

export default button => {
  onClick.listen(button)
}